// src/hooks/useReglagesTableau.ts — SCE Issues
// Les réglages du tableau de « Tous les problèmes » : colonnes, tri,
// regroupement et filtres restent d'une visite à l'autre — et d'un poste à
// l'autre. Mécanique commune (cache local + bloc de Prefs, bascule de rôle en
// lecture seule) : useReglagesBloc.

import { useCallback } from 'react'
import { lireReglages, type ReglagesTableau } from '@/utils/tableauProblemes'
import { useCurrentUser } from './useCurrentUser'
import { useReglagesBloc, type UseReglagesBloc } from './useReglagesBloc'

/** Clé du bloc dans le JSON `Prefs` de SCE_UserPrefs. */
export const CLE_BLOC_TABLEAU = 'listeProblemes'

export type UseReglagesTableau = UseReglagesBloc<ReglagesTableau>

export function useReglagesTableau(): UseReglagesTableau {
  const { isFournisseur } = useCurrentUser()
  const interne = !isFournisseur
  // Un fournisseur ne lit pas le référentiel : ni sa colonne, ni son filtre.
  const lire = useCallback((brut: unknown) => lireReglages(brut, interne), [interne])
  return useReglagesBloc(CLE_BLOC_TABLEAU, 'sce-issues:tableau', lire, interne ? 'interne' : 'fournisseur')
}
